import { render, staticRenderFns } from "./As.vue?vue&type=template&id=10cc4583&"
import script from "./As.vue?vue&type=script&lang=js&"
export * from "./As.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports